import BEImage from './BEImage';

export default BEImage;
